import apiClient from "../client";

// GET /api/associates?filter=new|available|partial  (no filter = all)
export const getAssociates = async (params = {}) => {
  const response = await apiClient.get("/associates", { params });
  return response.data;
};

// GET /api/associates/stats
// Returns: { total, fullyAllocated, partial, available, newCount, lastSyncedAt }
export const getAssociatesStats = async () => {
  const response = await apiClient.get("/associates/stats");
  return response.data;
};

// GET /api/associates/available-associates
// Returns bench + partial associates for allocation wizard Step 2
export const getAvailableAssociates = async () => {
  const response = await apiClient.get("/associates/available-associates");
  return response.data;
};

// GET /api/associates/available-associates → find one by id
// Used in edit mode to get live usedFte / availableFte / skills for an associate
export const getAssociateLiveFte = async (associateId) => {
  const response = await apiClient.get("/associates/available-associates");
  const all = response.data;
  return all.find((a) => a.associateId === associateId) ?? null;
};



// POST /api/associates/{associateId}/bench
// SCG only — adds associate to SCG bench pool.
// Auto-picks the lowest FREE UBL slot for the given quarter.
// Body: { quarter: "Q2-2026" }
export const addAssociateToBench = async (associateId, quarter) => {
  const response = await apiClient.post(`/associates/${associateId}/bench`, { quarter });
  return response.data;
};

// GET /api/associates/{associateId}/allocation-history
// Returns ACTIVE + ENDED allocations, including bench (SCG pool) periods
// flagged isBench, ordered by StartDate desc. An ongoing bench has endDate null.
export const fetchAllocationHistory = async (associateId) => {
  const response = await apiClient.get(`/associates/${associateId}/allocation-history`);
  return response.data;
};

// GET /api/associates/{associateId}/check-overlap?startDate=&endDate=
// Returns { overlaps, conflictStart, conflictEnd }
// Used by Step 3 wizard for inline date validation before submission
export const checkAllocationOverlap = async (associateId, startDate, endDate, fte = 1.0, excludeRequestId = null, excludeParentRequestId = null) => {
  const response = await apiClient.get(`/associates/${associateId}/check-overlap`, {
    params: {
      startDate,
      endDate,
      fte,
      ...(excludeRequestId       ? { excludeRequestId }       : {}),
      ...(excludeParentRequestId ? { excludeParentRequestId } : {}),
    },
  });
  return response.data;
};